export default __webpack_public_path__ + "static/media/06_tezba-min.f5e3453e.jpg";